module.exports = __webpack_public_path__ + "img/brand-shape-3.ba2b5769.png";